<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Ficha de notificação de caso suspeito"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-select
                        :options="data.form.casosSuspeitos"
                        :validations="validations.casoSuspeito"
                        label="Caso suspeito"
                        show-default-option
                        text-field="nome"
                        v-model="model.casoSuspeitoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                casoSuspeito: {required: true},
            }
        },
    },
    data: () => ({
        model: {
            casoSuspeitoId: null,
        },
    }),
    methods: {
        open() {
            this.create()

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        store() {
            const casoSuspeito = this.data.form.casosSuspeitos.find(casoSuspeito => casoSuspeito.id === this.model.casoSuspeitoId)

            this.data.model.casosSuspeitos.push({
                id: casoSuspeito.id,
                nome: casoSuspeito.nome,
                geraImpressao: casoSuspeito.geraImpressao,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.data.model.casosSuspeitos.find(casoSuspeito => casoSuspeito.id === this.model.casoSuspeitoId)) {
                        this.showValidationNotification('O caso suspeito já foi incluído.')
                        return
                    }

                    this.store()

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.casoSuspeitoId = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
}
</script>